import styled from 'styled-components'


export const Container = styled.div`
    display:flex;
    flex-direction: column-reverse;
    background: #fff;
    background-size: cover;
    justify-content: flex-start;
    padding-top: 30px;
    min-height: 100px;
    justify-content: flex-end;
    align-items: stretch;
    @media (min-width: 768px) { 
        flex-direction: column-reverse;
        padding-top: 30px;
    }
    @media (min-width: 992px) { 
        flex-direction: row;
        padding-top: 30px;
    }
    @media (min-width: 1200px) { 
        flex-direction: row;
        padding-top: 30px;
    }
`
export const FormContainer = styled.div`
    text-align: center;
    margin-top: 0;
    margin-right: 0;
    margin-left: 0;
    height: 100vh;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    background: rgba(255,255,255,.9);
    @media (min-width: 768px) { 
        margin-top: 0;
        margin-right: 0;
        margin-left: 0;
        height: 100vh;
    }
    @media (min-width: 992px) { 
        margin-top: 0;
        margin-right: 0;
        margin-left: 0;
        height: auto;
    }
    @media (min-width: 1200px) { 
        margin-top: 0;
        margin-right: 0;
        margin-left: 0;
        height: auto;
    }
`

export const Logo = styled.img`
    width: auto;
    max-height: 60px;
    display:none;
    @media (min-width: 768px) { 
        max-height: 60px;
        display:none;
    }
    @media (min-width: 992px) { 
        max-height: 95px;
        display:none;
    }
    @media (min-width: 1200px) { 
        max-height: 95px;
        display:block;
    }
`
export const Row = styled.div`
  

    form {
        display: flex;
        flex-direction: column;
    }
    

    span{
        margin-left:10px;
        font-size: 12px;
        color: #D50000;
        text-align: left;
    }
`

export const RowEnd = styled.div`
    margin-top: 60px;
    position: initial;

`
export const Col = styled.div`
    display: flex;
    margin: 20px 0;
    justify-content: space-around;
    align-items: center;
    @media (min-width: 768px) { 

    }
    @media (min-width: 992px) { 

    }
    @media (min-width: 1200px) { 

    }
`

export const Collogo = styled.div`
    display: flex;
    margin: 20px 0;
    justify-content: space-around;
    align-items: center;
    @media (min-width: 768px) { 

    }
    @media (min-width: 992px) { 

    }
    @media (min-width: 1200px) { 
        display:none;
    }
`

export const LoginNotice = styled.div`
    color:#92999F;
    font-size:18px;
    margin-bottom:50px;
`
